import React, { useCallback, useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import "../../css/entry.css";
import {
  BoxStyle,
} from "../../constantVaribles/constatanvariable";
import { useLocation, useNavigate } from "react-router-dom";
import apiClient from "../../BaseUrl/apiClient.js"
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import TokenService from "../../service/TokenService";
import ToasterAlerts from "../../components/ToasterAlerts";
import dayjs from "dayjs";
import SriyanshCardHeader from "../../components/CardHeader";
import EncryptService from "../../service/EncryptionService";
import ListHeaderTableComponent from "../../CustomComponant/ListHeaderTables";
import CustomTextField from "../../CustomComponant/CustomTextField ";
import DatePickerComponent from "../../CustomComponant/DateTimePickerField";
import NumericTextField from "../../CustomComponant/NeumericTextField";
import CustomDropdownMenu from "../../CustomComponant/DropDownMenu";
import TablewithSumFooter from "../../CustomComponant/TablewithSumFooter";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";



function BillReceiptEntry() {
  const navigate = useNavigate();
  const [poNumber, setpoNumber] = useState("");
  const [poItemName, setpoItemName] = useState("");
  const [poValue, setpoValue] = useState(0);
  const [poQuantity, setpoQuantity] = useState(0);
  const [poDate, setpoDate] = useState(Date);
  const [ConsigneeName, setConsigneeName] = useState("");
  const { state } = useLocation();
let indentId=state.indent_id;
  


    const [gemchecked, setgemChecked] = useState(false); // Default is false
    const [gemNumber, setGemNumber] = useState(null); 
    const [gemDate, setGemDate] = useState(null);


  
  const [suitabilityDate, setsuitabilityDate] = useState();

  
  const [suitableQty, setSuitableQuantity] = useState(0);
  const [billDate, setBillDate] = useState(null);
  const [billQuantity, setbillQuantity] = useState(0);
  const [billValue, setbillValue] = useState(0);
  const [reason, setReason] = useState("");
  const [BillReceiptDate, setBillReceiptDate] = useState(null);
  const [NodalBillReceiptDate, setNodalBillReceiptDate] = useState(null);
  const today = dayjs();


const[balItemQty,setbalItemQty]=useState(0);
const[balItemVal,setbalItemVal]=useState(0);


  const [billNumber, setbillNumber] = useState();
  const [error, setError] = useState("");
  const [errors, setErrors] = useState({});
  const [selectedOption, setSelectedOption] = useState("");
  const [showRemark, setShowRemark] = useState(true);

  const [partPayList, setpartPayList] = useState([]);

  
  const handleQuantityChange = (value) => {
    setbillQuantity(value);
    // Update errors as needed; example here:
    setErrors({
      qty:
        value && !/^(\d+(\.\d+)?)?$/.test(value)
          ? "Invalid quantity format"
          : "",
    });
  };

  const handleValueChange = (value) => {
    setbillValue(value);
    // Update errors as needed; example here:
    setErrors({
      val:
        value && !/^(\d+(\.\d+)?)?$/.test(value)
          ? "Invalid quantity format"
          : "",
    });
  };

  const handleClose = () => {
    navigate("../billpendinglist", { replace: true });
  };

  const handleOptionChange = (event) => {
    const selvalue = event.target.value;
    setSelectedOption(event.target.value);

    // alert(selvalue);
    if (selvalue === "0") {
      setShowRemark(true);
      setReason("");
    } else {
      setShowRemark(false);
    }
    setErrors({ selerr: "" });
  };

  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));

  //console.log(indentId);

  const InsertPOData = async (e) => {
    e.preventDefault();
    let formErrors = {};
   
    if (!billDate) {formErrors.errBillDate = "Invalid Bill Date";}
    if (!BillReceiptDate) {formErrors.errreceiptDate = "Invalid Bill Receipt Date";}
    if (!NodalBillReceiptDate) {formErrors.errnodalDate = "Invalid Nodal Push date Date";}

    if (!billNumber || billNumber.length === 0)
      formErrors.errBill = "Invalid Bill Number";

    if (parseFloat(billQuantity) > parseFloat(suitableQty))
      formErrors.qty = "Qty should be less or equel then Suitable Qty";

    if (parseFloat(billValue) > parseFloat(poValue))
      formErrors.val = "Value should be less or equel then PO Qty";

    if (!billQuantity || parseFloat(billQuantity) <= 0)
      formErrors.qty = "Qty should be more then zero";

    if (!billValue || parseFloat(billValue) <= 0)
      formErrors.val = "Value should be more then zero";

    if (selectedOption === "1") {
      if (reason.length === 0)
        formErrors.reasonerr = "Remark Should not be Blank";
    }

    if (selectedOption === "0") {
      setReason(" ");
    }

    if (selectedOption.length === 0) {
      formErrors.selerr = "Bill Receipt Type Not Selected";
    }
    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      const BillRecdt = new Date(BillReceiptDate);
      const BillReceiptDate1 =
        BillRecdt.getFullYear() +
        "/" +
        parseInt(BillRecdt.getMonth() + 1) +
        "/" +
        BillRecdt.getDate();

      const billdt = new Date(billDate);
      const billDate1 =
        billdt.getFullYear() +
        "/" +
        parseInt(billdt.getMonth() + 1) +
        "/" +
        billdt.getDate();

        const nodaldt = new Date(NodalBillReceiptDate);
        const nodaldt1 =
        nodaldt.getFullYear() +
          "/" +
          parseInt(nodaldt.getMonth() + 1) +
          "/" +
          nodaldt.getDate();
  



      apiClient.post("/BillEntry", {
          vponumber: poNumber,
          vbillnumber: billNumber,
          vbilldate: billDate1,
          vbillitemQty: billQuantity,
          vbillitemValue: billValue,
          vpaymenttype: selectedOption + " ",
          vremark: reason,
          vbillreceiptdate: BillReceiptDate1,
          ventryuser: uname,
          vip: ip,
          vnodaldate:nodaldt1,
        })
        .then(function (response) {
          setError(response.data);
          navigate("../billpendinglist", { replace: true });
        })
        .catch(function (error) {
          if (error.response.data && error.response.data.code==='ER_DUP_ENTRY') {
          alert("Duplicate Bill Number for this PO Not Allowed");
       }
     });
    }
  };

  const getdata = async (e) => {
   if (!indentId || indentId.trim() === "") return; 
    apiClient.post("/poDetailsBillReceived", {
        uname: uname,
        indentNumber: String(indentId),
      })
      .then(function (response) {
        setpoNumber(response.data[0].poNumber);

        setgemChecked(response.data[0].gemtype);
        setGemNumber(response.data[0].gemno);
        setGemDate(response.data[0].gemdate);



        setpoDate(response.data[0].PODate);
        setConsigneeName(response.data[0].POConsignee);
        setpoItemName(response.data[0].POItemName);
        setpoQuantity(response.data[0].POQty);
        setpoValue(response.data[0].POValue);
        //     //setitemreceivedDate(response.data[0].ItemReceivedDate);
        setsuitabilityDate(response.data[0].SuitabilityDate);
        setSuitableQuantity(response.data[0].receivedQty);
          setbillQuantity(response.data[0].balanceqty);

          setbillValue(response.data[0].balanceValue);
          setbalItemQty(response.data[0].balanceqty)
          setbalItemVal(response.data[0].balanceValue)

      })
      .catch(function (error) {
        setError(error);
      });
  };

  useEffect(() => {
    getdata();
    getpartpaidPOdata();
  },[]);

  const getpartpaidPOdata = useCallback(async () => {
    if (!poNumber || poNumber.trim() === "") return; // Early return if indentNo is not available
    try {
      // console.log("PO " + poNumber)
      const response = await apiClient.post("/partPaymentList_by_PONumber", {
        ponumber: poNumber,
      });

      setpartPayList(response.data);

      //console.log(response.data);
    } catch (err) {}
  }, [poNumber]); // Include indentNo in the dependency array if getPOdata depends on it

  useEffect(() => {
    // Update state if roles change (in case roles are updated dynamically)
    getpartpaidPOdata();
  }, [poNumber,getpartpaidPOdata]);

  const headers = [
    ["PO Number", "PO date", "Consignee"],
    ["Item Name", "PO Qty", "PO Value"],
    [ "Suitable Item Qty","Last Suitability Date", "Bill Item Qty(Max)"],
    ["Bill Item val(max)","GeM Bill Number","GeM Bill Date"]
  ];
  
  const gemno=gemchecked?gemNumber:'';
  const gemdt=gemchecked?gemDate:'';


  const rows = [
    [poNumber, poDate, ConsigneeName],
    [poItemName, poQuantity, poValue],
    [suitableQty,suitabilityDate,balItemQty],
    [balItemVal,gemno,gemdt],
  ];

  const columns = [
    "billnumber",
    "billdate",
     "paymentDesription",
    "remark",
    "billreceiptdate",
    "billitemquantity",
    "billitemValue",
  ];

  const columnNames = [
    "Bill Number",
    "Bill Date",
     "Payment Type",
    "Payment Description",
    "Bill Receipt Date",
    "Bill Qty.",
    "Bill Value",
  ]; // keys from your data objects

  const menuoptions = [
    { value: "0", label: "Full Payment" },
    { value: "1", label: "Partial Payment" },
    { value: "2", label: "Final Payment of Partial Paid" },
  ];



  const handleDateChange = (newDate, setDate) => {
    if (newDate) {
      setDate(newDate);
      setErrors({ ...errors, errDate: false }); // Clear error if a valid date is selected
    } else {
      setErrors({ ...errors, errDate: true }); // Show error if date is cleared
    }
  };

 return (
  <>
    <style>{`
      /* =========================================================
         BILL / INVOICE RECEIPT ENTRY
         DASHBOARD BLUE THEME
         ========================================================= */

      .bill-receipt-page {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        padding: 12px;
        overflow-x: hidden;
      }

      .bill-receipt-card {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;

        background: #ffffff;

        border: 1px solid #dbe5f1 !important;
        border-radius: 16px !important;

        overflow: hidden;

        box-shadow:
          0 5px 18px rgba(13, 71, 161, 0.10) !important;
      }

      /* =========================================================
         HEADER
         ========================================================= */

      .bill-receipt-header {
        width: 100%;
        min-height: 58px;

        display: flex;
        align-items: center;

        box-sizing: border-box;

        padding: 15px 20px;

        color: #ffffff;

        font-size: 20px;
        font-weight: 700;

        letter-spacing: 0.2px;

        background: linear-gradient(
          135deg,
          #0d47a1 0%,
          #1565c0 50%,
          #1976d2 100%
        );
      }

      .bill-receipt-content {
        width: 100%;
        max-width: 100%;
        min-width: 0;

        box-sizing: border-box;

        padding: 18px !important;
      }

      /* =========================================================
         PO DETAILS ACCORDION
         ========================================================= */

      .bill-po-accordion {
        width: 100%;
        max-width: 100%;
        min-width: 0;

        box-sizing: border-box;

        margin-bottom: 20px !important;

        border: 1px solid #d7e4f5 !important;
        border-radius: 12px !important;

        overflow: hidden;

        box-shadow:
          0 3px 12px rgba(13, 71, 161, 0.07) !important;
      }

      .bill-po-accordion::before {
        display: none;
      }

      .bill-po-summary {
        min-height: 52px !important;

        padding: 0 16px !important;

        background: linear-gradient(
          135deg,
          #eaf3ff 0%,
          #f5f9ff 100%
        ) !important;

        color: #0d47a1 !important;
      }

      .bill-po-summary .MuiAccordionSummary-content {
        margin: 12px 0 !important;
      }

      .bill-po-summary
        .MuiAccordionSummary-expandIconWrapper {
        color: #1565c0;
      }

      .bill-po-title {
        font-size: 16px !important;
        font-weight: 700 !important;
      }

      .bill-po-details {
        width: 100%;
        max-width: 100%;
        min-width: 0;

        box-sizing: border-box;

        padding: 16px !important;

        overflow: hidden;
      }

      /* =========================================================
         FORM
         ========================================================= */

      .bill-form {
        width: 100%;
        max-width: 100%;
        min-width: 0;

        box-sizing: border-box;

        margin-top: 18px;
      }

      .bill-form-grid {
        width: 100%;
        max-width: 100%;
        min-width: 0;

        box-sizing: border-box;

        display: grid;

        grid-template-columns:
          repeat(2, minmax(0, 1fr));

        gap: 16px;

        margin-top: 16px;
      }

      .bill-form-field {
        width: 100%;
        min-width: 0;

        box-sizing: border-box;
      }

      /* =========================================================
         PARTIAL PAYMENT REASON
         ========================================================= */

      .bill-reason-section {
        width: 100%;
        max-width: 100%;
        min-width: 0;

        box-sizing: border-box;

        margin-top: 16px;

        padding: 14px;

        background: #f8fbff;

        border: 1px solid #dce9f7;

        border-radius: 10px;
      }

      .bill-reason-title {
        margin-bottom: 10px;

        color: #0d47a1;

        font-size: 14px;
        font-weight: 700;
      }

      /* =========================================================
         PAYMENT HISTORY TABLE
         ========================================================= */

      .bill-table-section {
        width: 100%;
        max-width: 100%;
        min-width: 0;

        box-sizing: border-box;

        margin-top: 22px;

        overflow: hidden;
      }

      .bill-table-title {
        width: 100%;
        max-width: 100%;

        box-sizing: border-box;

        margin-bottom: 10px;

        padding: 10px 14px;

        background: linear-gradient(
          135deg,
          #edf5ff,
          #f7fbff
        );

        border-left: 4px solid #1565c0;

        border-radius: 7px;

        color: #0d47a1;

        font-size: 15px;
        font-weight: 700;

        white-space: normal;
        overflow-wrap: anywhere;
        word-break: break-word;
      }

      .bill-table-section table {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
      }

      /* =========================================================
         ACTION BAR
         ========================================================= */

      .bill-action-bar {
        width: 100%;
        max-width: 100%;
        min-width: 0;

        box-sizing: border-box;

        display: flex;

        flex-wrap: wrap;

        justify-content: flex-end;

        gap: 12px;

        margin-top: 24px;
      }

      .bill-action-btn {
        min-width: 135px;

        border: none;

        border-radius: 8px;

        padding: 10px 20px;

        color: #ffffff;

        font-size: 14px;

        font-weight: 700;

        cursor: pointer;

        box-shadow:
          0 3px 8px rgba(0, 0, 0, 0.12);

        transition: all 0.2s ease;
      }

      .bill-action-btn:hover {
        transform: translateY(-1px);

        box-shadow:
          0 5px 12px rgba(0, 0, 0, 0.18);
      }

      .bill-save-btn {
        background: linear-gradient(
          135deg,
          #0d47a1,
          #1976d2
        );
      }

      .bill-close-btn {
        background: linear-gradient(
          135deg,
          #c62828,
          #e53935
        );
      }

      .bill-action-btn:disabled {
        opacity: 0.65;

        cursor: not-allowed;

        transform: none;

        box-shadow: none;
      }

      /* =========================================================
         TABLET
         ========================================================= */

      @media (max-width: 900px) {

        .bill-receipt-page {
          padding: 8px;
        }

        .bill-receipt-content {
          padding: 14px !important;
        }

        .bill-form-grid {
          grid-template-columns: 1fr;
        }

        .bill-action-bar {
          justify-content: stretch;
        }

        .bill-action-btn {
          flex: 1 1 180px;
        }
      }

      /* =========================================================
         MOBILE
         ========================================================= */

      @media (max-width: 600px) {

        .bill-receipt-page {
          padding: 4px;
        }

        .bill-receipt-card {
          border-radius: 11px !important;
        }

        .bill-receipt-header {
          min-height: 50px;

          padding: 13px 14px;

          font-size: 17px;
        }

        .bill-receipt-content {
          padding: 10px !important;
        }

        .bill-po-summary {
          padding: 0 10px !important;
        }

        .bill-po-title {
          font-size: 14px !important;
        }

        .bill-po-details {
          padding: 8px !important;
        }

        .bill-form {
          margin-top: 12px;
        }

        .bill-form-grid {
          grid-template-columns: 1fr;

          gap: 10px;

          margin-top: 10px;
        }

        .bill-reason-section {
          margin-top: 12px;

          padding: 10px;
        }

        .bill-table-section {
          margin-top: 16px;
        }

        .bill-table-title {
          font-size: 13px;

          padding: 8px 10px;
        }

        .bill-action-bar {
          flex-direction: column;

          gap: 9px;

          margin-top: 18px;
        }

        .bill-action-btn {
          width: 100%;

          min-width: 0;

          flex: none;
        }
      }

      /* =========================================================
         VERY SMALL MOBILE
         ========================================================= */

      @media (max-width: 380px) {

        .bill-receipt-header {
          font-size: 16px;
        }

        .bill-receipt-content {
          padding: 7px !important;
        }

        .bill-po-details {
          padding: 5px !important;
        }
      }
    `}</style>

    <div className="bill-receipt-page">

      <Card className="bill-receipt-card">

        {/* =====================================================
            ERROR / MESSAGE
            ===================================================== */}

        {error && (
          <ToasterAlerts
            type="info"
            title="Message"
            errorMessage={error}
            displaytime={2000}
            handleClose={() => {
              setError("");
            }}
          />
        )}

        {/* =====================================================
            HEADER
            ===================================================== */}

        <div className="bill-receipt-header">
          Bill/Invoice Received Entry
        </div>

        <CardContent className="bill-receipt-content">

          {/* ===================================================
              PO DETAILS
          =================================================== */}

          <Accordion
            defaultExpanded
            className="bill-po-accordion"
          >
            <AccordionSummary
              expandIcon={<ArrowDownwardIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
              className="bill-po-summary"
            >
              <Typography
                component="span"
                className="bill-po-title"
              >
                PO Details
              </Typography>
            </AccordionSummary>

            <AccordionDetails className="bill-po-details">
              <ListHeaderTableComponent
                headers={headers}
                rows={rows}
              />
            </AccordionDetails>
          </Accordion>

          {/* ===================================================
              BILL ENTRY FORM
          =================================================== */}

          <div className="bill-form">

            {/* Bill Date + Bill Number */}
            <div className="bill-form-grid">

              <div className="bill-form-field">
                <DatePickerComponent
                  label="Bill/Invoice Date"
                  id="billdate"
                  value={billDate}
                  onChange={(newDate) =>
                    handleDateChange(
                      newDate,
                      setBillDate
                    )
                  }
                  error={errors.errBillDate}
                  maxDate={today}
                  minDate={
                    gemchecked
                      ? dayjs(gemDate)
                      : dayjs(poDate)
                  }
                />
              </div>

              <div className="bill-form-field">
                <CustomTextField
                  label="Bill/Invoice Number"
                  value={billNumber ?? ""}
                  onChange={(e) => {
                    setbillNumber(e.target.value);
                  }}
                  placeholder="Bill/Invoice Number"
                  maxLength={50}
                  error={!!errors.errBill}
                  helperText={errors.errBill}
                />
              </div>

            </div>

            {/* Quantity + Value */}
            <div className="bill-form-grid">

              <div className="bill-form-field">
                <NumericTextField
                  id="ItemQuantity"
                  label="Quantity"
                  title="Quantity"
                  error={errors.qty}
                  value={billQuantity ?? "0"}
                  onChange={handleQuantityChange}
                />
              </div>

              <div className="bill-form-field">
                <NumericTextField
                  id="ItemValue"
                  label="Item Value"
                  title="Item Value"
                  error={errors.val}
                  value={billValue ?? "0"}
                  onChange={handleValueChange}
                />
              </div>

            </div>

            {/* Bill Receipt Date + Payment Type */}
            <div className="bill-form-grid">

              <div className="bill-form-field">
                <DatePickerComponent
                  label="Bill/Invoice Receiving Date"
                  id="BillReceiptDate"
                  value={BillReceiptDate}
                  onChange={(newDate) =>
                    handleDateChange(
                      newDate,
                      setBillReceiptDate
                    )
                  }
                  error={errors.errreceiptDate}
                  maxDate={today}
                />
              </div>

              <div className="bill-form-field">
                <CustomDropdownMenu
                  options={menuoptions}
                  selectedOption={selectedOption}
                  handleOptionChange={handleOptionChange}
                  error={errors.selerr}
                  menulabel="Select Payment Option"
                />
              </div>

            </div>

            {/* Nodal Date */}
            <div className="bill-form-grid">

              <div className="bill-form-field">
                <DatePickerComponent
                  label="Bill Submitted to Nodal Section Date"
                  id="NodalSubmitBillDate"
                  value={NodalBillReceiptDate}
                  onChange={(newDate) =>
                    handleDateChange(
                      newDate,
                      setNodalBillReceiptDate
                    )
                  }
                  error={errors.errnodalDate}
                  maxDate={today}
                />
              </div>

              {/* Empty grid space intentionally kept
                  for desktop alignment */}
              <div />

            </div>

            {/* =================================================
                PARTIAL PAYMENT REASON
            ================================================= */}

            {!showRemark && (
              <div className="bill-reason-section">

                <div className="bill-reason-title">
                  Partial Payment Details
                </div>

                <CustomTextField
                  label="Reason Why ---> Partial Payment done"
                  value={reason ?? ""}
                  onChange={(e) => {
                    setReason(e.target.value);
                  }}
                  placeholder="Reason"
                  maxLength={100}
                  error={!!errors.reasonerr}
                  helperText={errors.reasonerr}
                />

              </div>
            )}

          </div>

          {/* ===================================================
              PART PAYMENT HISTORY
          =================================================== */}

          {partPayList.length > 0 && (
            <div className="bill-table-section">

              <div className="bill-table-title">
                Previous Bill / Part Payment Details
              </div>

              <TablewithSumFooter
                columns={columns}
                columnNames={columnNames}
                data={partPayList}
              />

            </div>
          )}

          {/* ===================================================
              ACTION BUTTONS
          =================================================== */}

          <div className="bill-action-bar">

            <button
              className="
                bill-action-btn
                bill-save-btn
              "
              type="button"
              onClick={InsertPOData}
              title="Click for Data Save"
            >
              Save Data
            </button>

            <button
              className="
                bill-action-btn
                bill-close-btn
              "
              type="button"
              onClick={handleClose}
              title="Close"
            >
              Close
            </button>

          </div>

        </CardContent>
      </Card>
    </div>
  </>
);
}

export default BillReceiptEntry;
